/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ChanceType = {
    properties: {
        translation: {
            type: 'Translation',
            isRequired: true,
        },
        key: {
            type: 'ChanceTypeEnum',
            isRequired: true,
        },
    },
} as const;
